import React, { useState } from "react";
import "./sudanLanding.scss";
import ImgAssessments from "../sudanimg/first-image.png";
import ImgScores from "../sudanimg/second-image.png";
import ImgContext from "../sudanimg/third-image.png";
import ImgProgress from "../sudanimg/forth-image.png";
import ImgTasks from "../sudanimg/fifth-image.png";
import { useLanguage } from "../i18n/LanguageContext";

/* Card glyphs mirroring the Figma icon set (assessment, analytics, edit,
   growth, search). 20px stroke icons that sit inside the blue icon chip. */
const IconAssessment = () => (
   <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
         d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9l-6-6z"
         stroke="#4158cf"
         strokeWidth="1.7"
         strokeLinejoin="round"
      />
      <path d="M14 3v6h6" stroke="#4158cf" strokeWidth="1.7" strokeLinejoin="round" />
      <path
         d="m8 14.5 1.7 1.7L13 13"
         stroke="#4158cf"
         strokeWidth="1.7"
         strokeLinecap="round"
         strokeLinejoin="round"
      />
   </svg>
);
const IconAnalytics = () => (
   <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M4 20V4" stroke="#4158cf" strokeWidth="1.7" strokeLinecap="round" />
      <path d="M4 20h16" stroke="#4158cf" strokeWidth="1.7" strokeLinecap="round" />
      <rect x="7" y="12" width="3" height="5" rx="1" stroke="#4158cf" strokeWidth="1.7" />
      <rect x="13" y="8" width="3" height="9" rx="1" stroke="#4158cf" strokeWidth="1.7" />
   </svg>
);
const IconContext = () => (
   <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
         d="M4 20h4l10-10a2.12 2.12 0 0 0-3-3L5 17v3z"
         stroke="#4158cf"
         strokeWidth="1.7"
         strokeLinejoin="round"
      />
      <path d="M13.5 6.5l3 3" stroke="#4158cf" strokeWidth="1.7" strokeLinecap="round" />
   </svg>
);
const IconProgress = () => (
   <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
         d="M4 15l5-5 4 4 7-7"
         stroke="#4158cf"
         strokeWidth="1.7"
         strokeLinecap="round"
         strokeLinejoin="round"
      />
      <path d="M15 7h5v5" stroke="#4158cf" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
   </svg>
);
const IconSearch = () => (
   <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <circle cx="11" cy="11" r="6" stroke="#4158cf" strokeWidth="1.7" />
      <path d="m20 20-3.5-3.5" stroke="#4158cf" strokeWidth="1.7" strokeLinecap="round" />
   </svg>
);

const FEATURES = [
   {
      title: "All your assessments, one system.",
      text: "Run multiple assessments across different donors, frameworks, and rounds.",
      Icon: IconAssessment,
      img: ImgAssessments,
      alt: "Assessment configuration screen"
   },
   {
      title: "Results the moment data comes in.",
      text: "Instant dashboards show scores, progress, and gaps. No spreadsheets.",
      Icon: IconAnalytics,
      img: ImgScores,
      alt: "Score overview dashboard"
   },
   {
      title: "Built for your context.",
      text: "Design assessments that reflect your domains, scoring logic, and language.",
      Icon: IconContext,
      img: ImgContext,
      alt: "Operational efficiency assessment sections"
   },
   {
      title: "Track progress over time.",
      text: "Performance history across rounds shows how your organization grows.",
      Icon: IconProgress,
      img: ImgProgress,
      alt: "Assessment round score"
   },
   {
      title: "Identify your weaknesses and strengths.",
      text: "KAPorg turns every gap into a task with an owner, deadline, and resources.",
      Icon: IconSearch,
      img: ImgTasks,
      alt: "Action plan task list"
   }
];

const PlatformFeatures = () => {
   const [active, setActive] = useState(0);
   const { t } = useLanguage();

   return (
      <section className="sd-section sd-features" id="features">
         <div className="container">
            <div className="sd-section-head">
               <h2>{t("Everything you need to get funded, in one place.")}</h2>
               <p>
                  {t(
                     "From assessment to action plan, KAPorg gives Sudanese organizations the tools to demonstrate readiness and unlock direct funding."
                  )}
               </p>
            </div>

            <div className="sd-feature-tabs">
               <div className="sd-feature-tablist" role="tablist">
                  {FEATURES.map((feature, index) => {
                     const Icon = feature.Icon;
                     return (
                        <button
                           key={feature.title}
                           type="button"
                           role="tab"
                           aria-selected={index === active}
                           className={`sd-feature-tab ${index === active ? "active" : ""}`}
                           onClick={() => setActive(index)}
                        >
                           <span className="sd-feature-icon" aria-hidden="true">
                              <Icon />
                           </span>
                           <span className="sd-feature-copy">
                              <h3>{t(feature.title)}</h3>
                              <p>{t(feature.text)}</p>
                           </span>
                        </button>
                     );
                  })}
               </div>
               <div className="sd-feature-panel" role="tabpanel">
                  <div className="sd-feature-shot">
                     <img
                        key={active}
                        src={FEATURES[active].img}
                        alt={FEATURES[active].alt}
                     />
                  </div>
               </div>
            </div>
         </div>
      </section>
   );
};

export default PlatformFeatures;
